import merge from 'lodash/merge';
import { combineReducers } from 'redux';
import coreReducers from 'core/reducers';

// Top level org config
import config from 'org/configs/org.config';

// Org reducers
import creditCardMarketingBanner from 'org/modules/CreditCardMarketingBanner/reducers';

export default combineReducers(merge(coreReducers, {
  orgConfig: () => config,
  creditCardMarketingBanner,
}));
